module.exports = __webpack_public_path__ + "static/media/Лого.724f9ac3.svg";